import { QuoteFormItemRequestParams, DeleteQuoteFormResponse } from '@lio/api-types';
import { formVersionQueryKeys } from '@services/formVersion/keys';
import { quoteFormQueryKeys } from '@services/quoteForm/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteQuoteForm = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const result = useMutation({
    mutationFn: ({ quoteId, quoteFormId }: QuoteFormItemRequestParams) =>
      client.delete(`quote/${quoteId}/quote-form/${quoteFormId}`).json<DeleteQuoteFormResponse>(),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['quote', { quoteId: variables.quoteId }],
      });
      queryClient.invalidateQueries({
        queryKey: quoteFormQueryKeys.searchWithParams({ quoteId: variables.quoteId }),
      });
      queryClient.invalidateQueries({
        queryKey: formVersionQueryKeys.get(variables.quoteId),
      });
    },
  });

  return { ...result, deleteQuoteForm: result.mutateAsync };
};
